var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"rotated arrow-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }